export default {
    sagemaker: {
        que: "Plataforma para construir, entrenar y poner en producción modelos de machine learning, con notebooks, cómputo de entrenamiento y endpoints.",
        patron: "lineal",
        nodos: [["Datos en S3", "datos"], ["Training Job", "engranaje"], ["Modelo", "ia"], ["Endpoint", "nube"]],
        pasos: ["Preparas los datos en un notebook o con Feature Store.", "El training job usa cómputo temporal para entrenar y guarda el modelo resultante.", "Publicas el modelo en un endpoint que responde predicciones por HTTP."],
        objetos: {
            "Notebooks": ["Entorno Jupyter para explorar datos y desarrollar el modelo.", 0],
            "Training Jobs": ["Entrenamiento del modelo en servidores que se crean y se apagan solos.", 1],
            "Modelos": ["Artefacto entrenado más la imagen de inferencia, listo para desplegar.", 2],
            "Endpoints": ["Servicio en línea que devuelve predicciones en tiempo real.", 3],
            "Pipelines": ["Flujo automático de preparación, entrenamiento y despliegue (MLOps).", 1],
            "Feature Store": ["Repositorio de variables calculadas, reutilizables en entrenamiento e inferencia.", 0],
            "Studio": ["Entorno web integrado de desarrollo de ML.", 0],
        },
    },
    bedrock: {
        que: "Acceso por API a modelos de IA generativa de distintos proveedores (Claude, Llama, Titan...), sin administrar infraestructura, con tus datos privados.",
        patron: "lineal",
        nodos: [["Tu aplicación", "servidor"], ["Guardrails", "escudo"], ["Modelo base", "ia"], ["Knowledge Base", "carpeta"]],
        pasos: ["La aplicación envía el texto o la imagen a Bedrock.", "Los guardrails filtran contenido y datos sensibles.", "El modelo responde apoyándose, si lo configuras, en tus documentos (RAG) para dar respuestas con tu información."],
        objetos: {
            "Modelos base": ["Modelos de lenguaje, imagen y embeddings disponibles bajo una misma API.", 2],
            "Agentes": ["Asistentes que planifican pasos y llaman a tus APIs para cumplir una tarea.", 2],
            "Knowledge Bases": ["Tus documentos indexados para que el modelo responda con ellos (RAG).", 3],
            "Guardrails": ["Reglas de seguridad: temas prohibidos, datos personales, lenguaje dañino.", 1],
            "Provisioned Throughput": ["Capacidad reservada de un modelo para rendimiento constante.", 2],
        },
    },
    rekognition: {
        que: "Análisis de imágenes y video: detecta objetos, personas, rostros, texto y contenido inapropiado, y compara caras.",
        patron: "lineal",
        nodos: [["Imagen o video", "video"], ["Rekognition", "lupa"], ["Etiquetas y rostros", "ia"]],
        pasos: ["Envías una imagen o un video desde S3 o la aplicación.", "Rekognition lo analiza con modelos de visión y devuelve etiquetas, cuadros delimitadores y puntajes de confianza."],
        objetos: {
            "Colecciones": ["Base de rostros indexados para buscar coincidencias.", 2],
            "Proyectos": ["Modelos personalizados entrenados con tus propias imágenes.", 1],
            "Stream Processors": ["Análisis continuo de video en vivo desde Kinesis.", 0],
        },
    },
    comprehend: {
        que: "Entiende texto: sentimiento, entidades (personas, lugares, fechas), idioma, temas y datos personales.",
        patron: "lineal",
        nodos: [["Texto (reseñas, correos)", "archivo"], ["Comprehend", "ia"], ["Sentimiento y entidades", "grafico"]],
        pasos: ["Envías documentos de texto.", "Comprehend identifica idioma, sentimiento, entidades y frases clave, y devuelve el resultado estructurado."],
        objetos: {
            "Jobs": ["Análisis por lotes de muchos documentos guardados en S3.", 1],
            "Clasificadores": ["Modelos propios para clasificar textos en tus categorías.", 1],
            "Endpoints": ["Servicio en línea para usar un modelo propio en tiempo real.", 1],
        },
    },
    textract: {
        que: "Extrae texto, tablas y formularios de documentos escaneados (facturas, contratos, cédulas) más allá del OCR simple.",
        patron: "lineal",
        nodos: [["Documento escaneado", "archivo"], ["Textract", "lupa"], ["Datos estructurados", "datos"]],
        pasos: ["Subes la imagen o PDF del documento.", "Textract reconoce texto, identifica tablas y pares campo-valor, y devuelve datos listos para tu sistema."],
        objetos: { "Análisis de documentos": ["Extracción de texto, tablas, formularios, facturas o documentos de identidad.", 1] },
    },
    transcribe: {
        que: "Convierte voz en texto: reuniones, llamadas y videos, con puntuación, separación de hablantes y vocabulario propio.",
        patron: "lineal",
        nodos: [["Audio o video", "video"], ["Transcribe", "ia"], ["Texto con tiempos", "archivo"]],
        pasos: ["Entregas un archivo o una transmisión de audio.", "Transcribe reconoce el habla y devuelve la transcripción con marcas de tiempo y hablantes."],
        objetos: {
            "Jobs": ["Cada transcripción solicitada y su estado.", 1],
            "Vocabularios personalizados": ["Términos propios (marcas, tecnicismos) para mejorar el reconocimiento.", 1],
        },
    },
    polly: {
        que: "Convierte texto en voz natural, en muchos idiomas y voces, para asistentes, lectura de contenidos o avisos.",
        patron: "lineal",
        nodos: [["Texto", "archivo"], ["Polly", "ia"], ["Audio (MP3)", "video"]],
        pasos: ["Envías el texto y eliges voz e idioma.", "Polly sintetiza el audio y lo entrega como archivo o flujo."],
        objetos: {
            "Voces": ["Voces neuronales y estándar en distintos idiomas y acentos.", 1],
            "Léxicos": ["Reglas de pronunciación para nombres y siglas.", 1],
            "Tareas de síntesis": ["Conversión asíncrona de textos largos hacia S3.", 1],
        },
    },
    translate: {
        que: "Traducción automática de texto entre más de 70 idiomas, en tiempo real o por lotes.",
        patron: "lineal",
        nodos: [["Texto en español", "archivo"], ["Translate", "ia"], ["Texto en inglés", "archivo"]],
        pasos: ["Envías el texto y los idiomas de origen y destino.", "Translate devuelve la traducción, respetando la terminología que definiste."],
        objetos: {
            "Jobs": ["Traducción por lotes de muchos documentos.", 1],
            "Terminología": ["Glosario para traducir siempre igual ciertos términos.", 1],
        },
    },
    lex: {
        que: "Crea chatbots de voz y texto con comprensión del lenguaje: interpreta lo que el usuario quiere decir y conduce la conversación.",
        patron: "lineal",
        nodos: [["Usuario", "usuario"], ["Bot Lex", "ia"], ["Intent + Slots", "engranaje"], ["Tu backend (Lambda)", "funcion"]],
        pasos: ["El usuario escribe o habla.", "Lex detecta la intención (intent) y pregunta por los datos que faltan (slots).", "Con todo completo, llama a tu función para ejecutar la acción y responde al usuario."],
        objetos: {
            "Bots": ["El asistente conversacional con sus idiomas y su configuración.", 1],
            "Intents": ["Lo que el usuario quiere lograr (reservar, consultar saldo).", 2],
            "Slots": ["Datos que el bot debe obtener (fecha, destino, monto).", 2],
        },
    },
    kendra: {
        que: "Buscador empresarial inteligente: responde preguntas en lenguaje natural sobre tus documentos, wikis y bases de conocimiento.",
        patron: "lineal",
        nodos: [["Fuentes (S3, SharePoint...)", "carpeta"], ["Índice Kendra", "lupa"], ["Pregunta del usuario", "usuario"]],
        pasos: ["Los conectores indexan documentos de tus fuentes.", "El usuario pregunta en lenguaje natural y Kendra devuelve la respuesta precisa y el documento de origen."],
        objetos: {
            "Índices": ["Almacén de búsqueda con los documentos procesados.", 1],
            "Data Sources": ["Conectores a tus repositorios de documentos.", 0],
        },
    },
    forecast: {
        que: "Pronósticos de series de tiempo (demanda, ventas, inventario) usando los mismos modelos que Amazon.com.",
        patron: "lineal",
        nodos: [["Historial de ventas", "datos"], ["Predictor", "ia"], ["Pronóstico", "grafico"]],
        pasos: ["Cargas el historial como dataset.", "Forecast entrena y compara varios algoritmos y elige el más preciso, y entrega el pronóstico con rangos de confianza."],
        objetos: {
            "Datasets": ["Series de tiempo y datos relacionados que alimentan el modelo.", 0],
            "Predictores": ["Modelos entrenados que generan los pronósticos.", 1],
        },
    },
    personalize: {
        que: "Recomendaciones personalizadas (productos, contenido) en tiempo real, aprendiendo de lo que hace cada usuario.",
        patron: "lineal",
        nodos: [["Interacciones de usuarios", "usuario"], ["Solución (modelo)", "ia"], ["Campaña", "nube"], ["Recomendaciones", "grafico"]],
        pasos: ["Cargas el historial de interacciones de usuarios e ítems.", "Personalize entrena una solución con ese historial.", "Una campaña la publica y tu aplicación pide recomendaciones para cada usuario."],
        objetos: {
            "Datasets": ["Usuarios, ítems e interacciones con los que aprende el modelo.", 0],
            "Soluciones": ["Modelo de recomendación entrenado.", 1],
            "Campañas": ["Endpoint que entrega las recomendaciones en tiempo real.", 2],
        },
    },
    q: {
        que: "Asistente de IA generativa para empresas: responde preguntas con la información de tus sistemas y ayuda a los desarrolladores a programar.",
        patron: "lineal",
        nodos: [["Empleado", "usuario"], ["Amazon Q", "ia"], ["Conectores", "carpeta"]],
        pasos: ["El empleado hace una pregunta en lenguaje natural.", "Amazon Q busca en tus fuentes conectadas respetando los permisos de cada persona y responde citando el origen."],
        objetos: {
            "Aplicaciones": ["Instancia del asistente con su configuración y usuarios.", 1],
            "Conectores": ["Integraciones con tus fuentes (Confluence, S3, SharePoint...).", 2],
        },
    },
};
